import { Component, ViewChild } from '@angular/core';
import { menus } from './shared/data/menu';
import { MatDrawer, MatDrawerMode } from '@angular/material/sidenav';
import { BreakpointObserver } from '@angular/cdk/layout';
import { LayoutService } from './@theme/services/layout.service';
import { KeycloakService } from 'keycloak-angular';
import { UserKeycloak } from './shared/model/user.keycloak';
import { ruoli } from './shared/data/ruoli';
import { SpinnerService } from './shared/services/spinner.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
  showSpinner: boolean = true;

    // public props
    @ViewChild('sidebar') sidebar!: MatDrawer;
    menus = menus;
    modeValue: MatDrawerMode = 'side';
    currentApplicationVersion = 1.0;
    userProfile:UserKeycloak| undefined;
    // Constructor
    constructor(
      private breakpointObserver: BreakpointObserver,
      private layoutService: LayoutService,private keycloakService: KeycloakService,private spinnerService: SpinnerService
    ) {}
   
    async ngOnInit() {
      this.spinnerService.spinnerState$.subscribe(isVisible => {
        this.showSpinner = isVisible;
      });
            this.breakpointObserver.observe(['(min-width: 1025px)', '(max-width: 1024.98px)']).subscribe((result) => {
        if (result.breakpoints['(max-width: 1024.98px)']) {
          this.modeValue = 'over';
        } else if (result.breakpoints['(min-width: 1025px)']) {
          this.modeValue = 'side';
        }
      });
  
      this.layoutService.layoutState.subscribe(() => {
        this.sidebar.toggle();
      });
      const ruoliKey = await this.keycloakService.getUserRoles()
      this.userProfile = {
        profile: await this.keycloakService.loadUserProfile(),
        role: ruoliKey,
        ruoloGenomica: ruoliKey.filter(r => ruoli.includes(r))[0]
      }
      this.menus=this.menus.filter((f:any) => this.userProfile?.ruoloGenomica === f.ruolo || !f.ruolo);
    }
}
